<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ props, on }">
      <v-chip color="primary" small v-bind="props" v-on="on">
        {{ label }}
      </v-chip>
    </template>
    <v-card
      class="pa-3 d-flex flex-column gap-2 rounded-lg"
      style="max-width: 380px !important"
    >
      <v-chip-group v-model="dateFilterPredefined" color="primary" column>
        <v-chip
          v-for="option in dateFilterPredefinedOptions"
          :key="option.label"
          small
        >
          {{ option.label }}
        </v-chip>
      </v-chip-group>

      <v-text-field
        v-model="localFilters.startDate"
        label="Data de início"
        clearable
        type="datetime-local"
        outlined
        dense
        hide-details
      />
      <v-text-field
        v-model="localFilters.endDate"
        label="Data de fim"
        clearable
        type="datetime-local"
        outlined
        dense
        hide-details
      />
      <div class="d-flex justify-space-between mt-2">
        <v-btn text color="primary" @click="cancel" small> Cancelar </v-btn>
        <v-btn color="primary" @click="save" depressed small> Aplicar </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "ReportDateFilter",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    menu: false,
    localFilters: { startDate: null, endDate: null },
    dateFilterPredefinedOptions: [
      {
        label: "Hoje",
        start: moment().startOf("day"),
        end: moment().endOf("day"),
      },
      {
        label: "Ontem",
        start: moment().subtract(1, "day").startOf("day"),
        end: moment().subtract(1, "day").endOf("day"),
      },
      {
        label: "Essa semana",
        start: moment().startOf("week"),
        end: moment().endOf("week"),
      },
      {
        label: "Semana passada",
        start: moment().subtract(1, "week").startOf("week"),
        end: moment().subtract(1, "week").endOf("week"),
      },
      {
        label: "Esse mês",
        start: moment().startOf("month"),
        end: moment().endOf("month"),
      },
      {
        label: "Mês passado",
        start: moment().subtract(1, "month").startOf("month"),
        end: moment().subtract(1, "month").endOf("month"),
      },
    ],
  }),
  methods: {
    save() {
      this.menu = false;
      this.filters = Object.assign(this.filters, {
        startDate: this.localFilters.startDate,
        endDate: this.localFilters.endDate,
      });
    },
    load(value) {
      this.localFilters = structuredClone(value || this.value);
    },
    cancel() {
      this.load();
      this.menu = false;
    },
  },
  computed: {
    filters: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    dateFilterPredefined: {
      get() {
        if (!this.filters?.startDate || !this.filters?.endDate) return null;
        return this.dateFilterPredefinedOptions.findIndex(
          (option) =>
            option.start.isSame(this.localFilters?.startDate, "minute") &&
            option.end.isSame(this.localFilters?.endDate, "minute")
        );
      },
      set(value) {
        if (value !== undefined) {
          if (this.dateFilterPredefinedOptions[value]) {
            this.localFilters.startDate = this.dateFilterPredefinedOptions[
              value
            ].start.format("YYYY-MM-DDTHH:mm:ss");
            this.localFilters.endDate = this.dateFilterPredefinedOptions[
              value
            ].end.format("YYYY-MM-DDTHH:mm:ss");
          }
        } else {
          this.localFilters.startDate = null;
          this.localFilters.endDate = null;
        }
      },
    },
    label() {
      const selected = this.dateFilterPredefinedOptions.find(
        (option) =>
          option.start.isSame(this.filters.startDate, "minute") &&
          option.end.isSame(this.filters.endDate, "minute")
      )?.label;
      if (selected) return selected;

      if (this.filters.startDate && !this.filters.endDate) {
        return `A partir de ${moment(this.filters.startDate).format(
          "DD/MM HH:mm"
        )}`;
      }

      if (!this.filters.startDate && this.filters.endDate) {
        return `Até ${moment(this.filters.endDate).format("DD/MM HH:mm")}`;
      }

      if (this.filters.startDate && this.filters.endDate) {
        return `De ${moment(this.filters.startDate).format(
          "DD/MM HH:mm"
        )} até ${moment(this.filters.endDate).format("DD/MM HH:mm")}`;
      }

      return "Todas as datas";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.load(newValue);
      },
    },
    menu: {
      immediate: true,
      handler(newValue) {
        if (!newValue) this.save();
        else this.load();
      },
    },
  },
};
</script>
